import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Comm from '../comm/comm';
import Context from '../context/context';
import Translation from '../translation/translation';

export default class PackingListPrices extends Component {

    constructor(props) {
        super(props);
        if (!Comm.ValidSession())
            return;

        this.ChangePrice = this.ChangePrice.bind(this);
        this.SaveData = this.SaveData.bind(this);

        this.state = { ShowError: false };
    }


    componentDidMount() {
        var sid = Context.GetContext().Sid;
        var data = {
            session: sid,
            packing_list: this.props.packingListId
        };
        var amounts = Comm.CallServerFunction("invoices/packing_list_prices", data);
        var tg = Comm.CallServerFunction("invoices/tax_groups", { session: sid });
        this.setState({
            amounts: amounts,
            taxGroups: tg,
            taxGroup: amounts.result.tax_group || tg.data.default_group
        });


    }

    ChangePrice(rn, value) {
        var amounts = this.state.amounts;
        amounts.result.positions[rn].price = value;
        this.setState({
            amounts: amounts
        });

    }

    SaveData() {
        this.setState({ ShowError: true });
        var error = false;
        this.state.amounts.result.positions.forEach(x => { if ((x.price || "") === "") error = true; });
        if (error)
            return;
        this.state.amounts.result.positions.forEach(x => x.price = parseFloat(x.price));
        var sid = Context.GetContext().Sid;
        var data = {
            session: sid,
            values: JSON.stringify({
                positions: this.state.amounts.result.positions,
                tax_group: this.state.taxGroup,
                packing_list: this.props.packingListId
            })
        }
        Comm.CallServerFunction("invoices/save_packing_list_prices", data);
        this.props.closeFunc();
    }


    render() {

        if (!Comm.ValidSession()) {
            Context.Logout();
            return (<Redirect to="/login" push></Redirect>);
        }


        var self = this;

        return (
            <div className="col-md-12">
                <div className="col-md-12">
                    <label className="control-label">{Translation.Trans("taxgroup")}</label>
                    {
                        this.state.taxGroups ?
                            <select id="ddlTaxGroup" className="form-control" onChange={(e) => this.setState({ taxGroup: e.target.value })} value={this.state.taxGroup}>
                                {this.state.taxGroups.data.tax_groups.map(x => <option value={x.id}>{x.code} {x.dds_perc}%</option>)}
                            </select>
                            : null
                    }
                </div>
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-3"><label className="control-label">{Translation.Trans("article")}</label></div>
                        <div className="col-md-3"><label className="control-label">{Translation.Trans("weight")}</label></div>
                        <div className="col-md-6"><label className="control-label">{Translation.Trans("price")}</label></div>
                    </div>
                    {
                        this.state.amounts ?
                            this.state.amounts.result.positions.map((item, rn) =>
                                <div className="row" key={item.id}>
                                    <div className="col-md-3">
                                        {item.name}
                                    </div>
                                    <div className="col-md-3">
                                        {item.weight}
                                    </div>
                                    <div className="col-md-6">
                                        <input type="number" className="form-control" value={item.price} onChange={(e) => self.ChangePrice(rn, e.target.value)}></input>
                                        {this.state.ShowError && (item.price || "") === "" ? <div className="alert alert-danger">{Translation.Trans("entervalue")}</div> : null}
                                    </div>
                                </div>
                            )
                            : null
                    }
                    <div className="row">
                        <div className="col-md-3"><button className="btn btn-primary" onClick={self.SaveData}>{Translation.Trans("save")}</button></div>
                        <div className="col-md-3"><button className="btn btn-primary" onClick={self.props.closeFunc}>{Translation.Trans("cancel")}</button></div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/packinglistprices.js